export const MATERIAL_TRACKING_BASE_API_PATH = "/material-tracking";
export const MATERIAL_LIST_COLUNMN_DEFS = [
  {
    headerName: "Id",
    width: 100,
    field: "package_no",
    editable: false,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    cellRenderer: "MaterialListCellButton",
    primarykeyfield: true,
  },
  {
    headerName: "Program",
    width: 100,
    field: "program.name",
    editable: false,
  },
  {
    headerName: "Project",
    width: 100,
    field: "project.name",
    editable: false,
  },
  {
    headerName: "Contractor Name",
    width: 150,
    field: "contractor_name",
    editable: false,
  },
  {
    headerName: "Discipline",
    width: 80,
    field: "discipline.name",
    editable: false,
  },
  {
    headerName: "PO Number",
    width: 80,
    field: "amns_po_no",
    editable: false,
  },
  {
    headerName: "Packing Type",
    width: 80,
    field: "packing_type.name",
    editable: false,
  },
  {
    headerName: "Location",
    width: 80,
    field: "location.name",
    editable: false,
  },
  {
    headerName: "Created at",
    width: 80,
    field: "created_date",
    editable: false,
  },
];
export const NOTIFICATION_MEESAGES = {
  WARNNIG_ALL_EXCEL_EXPORT: "Please wait! Exporting all data",
  WARNNIG_SELECTED_EXCEL_EXPORT: "Please wait! Exporting selected data",
  SUCCESS_EMAIL_EXCEL_EXPORT: "You will receive the exported data in your email shortly!",
  SUCCESS_EXCEL_EXPORT: "Successfully Exported to Excel",
  ERROR_EXCEL_EXPORT: "Error Exporting Data to Excel"
};

export const MATERIAL_APP = "material_tracking";
export const MATERIAL_MODEL = "TransMaterialInfo";
